import { render, staticRenderFns } from "./bindingCard.vue?vue&type=template&id=e027a1cc&scoped=true"
import script from "./bindingCard.vue?vue&type=script&lang=js"
export * from "./bindingCard.vue?vue&type=script&lang=js"
import style0 from "./bindingCard.vue?vue&type=style&index=0&id=e027a1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e027a1cc",
  null
  
)

export default component.exports